const map = {
	"./menu_admin.svg": 9224,
	"./menu_admins.svg": 6123,
	"./menu_ids.svg": 8999,
	"./menu_licenses.svg": 3555,
	"./menu_modules.svg": 5650,
	"./menu_tenant.svg": 3531,
	"./menu_tenants.svg": 6114,
	"./menu_url.svg": 4998
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7992;